import Slider from 'rc-slider'
import React, { FC } from 'react'


interface QualitySliderProps {
    value: number;
    onChange?: (value: number | number[]) => void;
}

const QualitySlider: FC<QualitySliderProps> = ({ value, onChange }) => {
    return (
        <div>
            <Slider
                styles={{
                    track: { background: 'var(--theme)' },
                    handle: {
                        borderColor: 'var(--theme)',
                        borderWidth: 3,
                        background: '#E2E8F0',
                        opacity: 1,
                        boxShadow: 'none',
                        width: 17,
                        height: 17
                    },
                    rail: {
                        background: '#EDF1F3'
                    }
                }}
                className='quality-slider'
                step={1}
                min={0}
                dots={true}
                dotStyle={{
                    background: '#282D46',
                    width: 1,
                    height: 16,
                    border: '1px solid #282D46',
                    bottom: -7,
                    opacity: 0.7
                }}
                max={10}
                onChange={onChange}
                value={value}
            />
            <style>
                {`
                   .quality-slider .rc-slider-handle::before {
                        content: " ${value}";
                        position: absolute;
                        top: -35px;
                        left: -10px;
                        width: 32px;
                        height: 22px;
                        background-color: var(--theme) !important;
                        border-radius: 5px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: white;
                        font-family: 'InterBold', sans-serif;
                        font-size: 14px;
                    }

                    .quality-slider .rc-slider-handle::after {
                        content: " ";
                        position: absolute;
                        top: -15px; /* Position the arrow directly below the box */
                        left: 50%; /* Center it horizontally */
                        transform: translateX(-50%); /* Center the arrow perfectly */
                        width: 0;
                        height: 0;
                        border-left: 10px solid transparent;
                        border-right: 10px solid transparent;
                        border-top: 10px solid var(--theme); /* Make the arrow match the box color */
                    }
                `}
            </style>
        </div>
    )
}

export default QualitySlider